import { Link, Outlet, useLocation } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";

const Configuration = () => {
  const routes = all_routes;
  const location = useLocation();
  const isActive = (route: string) => location.pathname === route;
  return (
    <div>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Configuration</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      configuration
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            {/* /Breadcrumb */}
            <ul className="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
              <li className="nav-item">
                <Link className="nav-link active" to={routes.configuration}>
                  <i className="fab fa-whatsapp me-2"></i>
                  Whatsapp Business
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="#">
                  <i className="fas fa-envelope me-2"></i>
                  Email
                </Link>
              </li>
            </ul>
            <div className="row">
              <div className="col-xl-2 theiaStickySidebar">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column list-group settings-list">
                      <Link
                        to={routes.fonada}
                        className={`d-inline-flex align-items-center rounded py-2 px-3 ${
                          isActive(routes.fonada) ? "active" : ""
                        }`}>
                        <i
                          className={`ti me-2 ${
                            isActive(routes.fonada)
                              ? "ti-arrow-badge-right"
                              : ""
                          }`}
                        />
                        Fonada
                      </Link>

                      {/* <Link
                        to={routes.twillio}
                        className={`d-inline-flex align-items-center rounded py-2 px-3 ${
                          isActive(routes.twillio) ? "active" : ""
                        }`}
                      >
                        <i
                          className={`ti me-2 ${
                            isActive(routes.twillio)
                              ? "ti-arrow-badge-right"
                              : ""
                          }`}
                        />
                        Twillio
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <Outlet />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
            <p className="mb-0">2025 © ZYVO.</p>
            <p>
              Designed &amp; Developed By{" "}
              <Link to="#" className="text-primary">
                ZYVO
              </Link>
            </p>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>
    </div>
  );
};

export default Configuration;
